import { isMember } from "../constants"
import { location as Auditorium } from "./rooms/Auditorium"
import { location as Atrium } from "./rooms/Atrium"
import { location as OnDemand } from "./rooms/OnDemand"
import { location as ExplorationZone } from "./rooms/ExplorationZone"
import { location as ExibitionHall } from "./rooms/ExibitionHall"

export default () => <div class="topnavtk2" id="myTopnavtk2">
	<a data-event-category="Navbar" data-event-action="Link Click" data-event-label="Leave Event" href="https://www.isflive.org/s/" id="LeaveEvent" class="activetk2">Leave Event</a>

	<div class="dropdowntk2">
		<button class="dropbtntk2">Schedule
			<i class="fa fa-caret-down" />
		</button>
		<div class="dropdown-contenttk2">
			<a data-event-category="Navbar" data-event-action="Link Click" target="_blank" data-event-label="Full Schedulle" href="https://isfcongress.tkeventsregistration.com/2022/fullschedule" title="Full Schedulle">Full Schedule</a>
			<a data-event-category="Navbar" data-event-action="Link Click" target="_blank" data-event-label="Personal Agenda" href="https://isfcongress.tkeventsregistration.com/2022/personalschedule" title="Personal Agenda">Personal Agenda</a>
		</div>
	</div>
	<a data-event-category="Navbar" data-event-action="Link Click" data-event-label="Atrium" href={Atrium} id="Atrium">Atrium</a>
	{isMember ?
		<div class="dropdowntk2">
			<button class="dropbtntk2">Room Navigation
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href={Atrium} data-event-category="Navbar" data-event-action="Link Click" data-event-label="Atrium" title="Atrium">Atrium</a>
				{ new Date() < new Date("2022-11-17 08:00:00") ? <a href={Auditorium} data-event-category="Navbar" data-event-action="Link Click" data-event-label="Auditorium" title="Auditorium">Auditorium</a> : null }
				<a href={ExibitionHall} data-event-category="Navbar" data-event-action="Link Click" data-event-label="Exhibition Hall" title="Exhibition Hall">Exhibition Hall</a>
				<a href={ExplorationZone} data-event-category="Navbar" data-event-action="Link Click" data-event-label="ISF Exploration Zone" title="ISF Exploration Zone">ISF Exploration Zone</a>
				<a href={OnDemand} data-event-category="Navbar" data-event-action="Link Click" data-event-label="On-Demand" title="On-Demand">On-Demand</a>
			</div>
		</div>
		: null}
	<div class="dropdowntk2">
		<button class="dropbtntk2">Directories
			<i class="fa fa-caret-down" />
		</button>
		<div class="dropdown-contenttk2">
			{isMember ? <>
				<a href="https://isfcongress.tkeventsregistration.com/2022/attendeedirectory" data-event-category="Navbar" target="_blank" data-event-action="Link Click" data-event-label="Attendee Directory" title="Attendee Directory">Attendee Directory</a>
				<a href="https://isfcongress.tkeventsregistration.com/2022/speakerdirectory" data-event-category="Navbar" target="_blank" data-event-action="Link Click" data-event-label="Speaker Directory" title="Speaker Directory">Speaker Directory</a>
			</> : null}
			<a href="https://isfcongress.tkeventsregistration.com/2022/sponsordirectory" data-event-category="Navbar" target="_blank" data-event-action="Link Click" data-event-label="Sponsor Directory" title="Sponsor Directory">Sponsor Directory</a>
		</div>
	</div>
</div>


